<template>
    <div class="page-wrapper">
        <div class="page-content" style="padding-top:36px;">
            <div class="title">千人千面</div>
            <div class="sub-title">以人为本的使用体验，从用户视角构建产品，成就组织与个人，更高效、更愉悦。</div>
            <!-- 轮播组件 -->
            <div style="display:flex; align-items: center; justify-content: center; height:640px; width:100%; margin-top:80px; ">
                <div style="width:140px; height:560px;"><RadiusScroller  /></div>
                <div style="margin:-40px 30px 0 30px" ><i class="ri-arrow-right-double-line" style="font-size:80px; opacity:0.2; color:#0071ae;" ></i></div>
                <div style="width:70.4%; height:100%;"><CrossScroller/></div>
            </div>
        </div>
    </div>
</template>

<script> 
    import RadiusScroller from '@/components/RadiusScroller/index.vue';
    import CrossScroller from '@/components/CrossScroller/index.vue';
    export default {
        components:{
            RadiusScroller,
            CrossScroller
        }
    }
</script>